<template>
  <div>
    <div class="container">
      <div class="header">
        <img class="header__avatar" v-if="!!member" :src="member.avatar_url" />
        <h1 class="header__copy" v-if="!!member">
          {{member.username}},
          <br />let's build a better you.
        </h1>
      </div>
      <img src="../assets/img/Web_SelectPlan_blurb.png" />
      <div class="plans-container" v-if="stripePlans">
        <button
          class="plan plan--yearly"
          v-on:click="selectPlan(stripePlans.yearly)"
        >
          <div class="plan__text" style="min-width:320px">Try it free for 7 days</div>
          <div
            class="plan__sub-text"
          >Then {{(stripePlans.yearly.localCost/12).toFixed(2)}} {{stripePlans.currency}} a month. Billed {{stripePlans.yearly.localCost}} Annually</div>
        </button>
        <button
        v-if="0"
          class="plan plan--monthly"
          v-on:click="selectPlan(stripePlans.monthly)">
          <div class="plan__text">Try it free for only 1 week</div>
          <div
            class="plan__sub-text"
          >Then {{stripePlans.monthly.localCost}} {{stripePlans.currency}} a month. Billed Monthly</div>
        </button>

        <!-- <pre>{{stripePlans}}</pre> -->
        <!-- <img
          v-on:click="selectPlan({revenue: '99.99', stripeId: stripePlans.yearly.id, id:'live.studio.ios.YearlyFullService', type: 'yearly', predicted_ltv: stripePlans.yearly.predicted_ltv, value: stripePlans.yearly.value})"
          src="../assets/img/Button_Try_It_2_Weeks.png"
        />
        <img
          v-on:click="selectPlan({revenue: '14.99', stripeId: stripePlans.monthly.id, id:'live.studio.ios.MonthlyFullService', type: 'monthly', predicted_ltv: stripePlans.monthly.predicted_ltv, value: stripePlans.monthly.value})"
          src="../assets/img/Button_Try_It_1_Week.png"
        />-->
      </div>

      <!-- <img src="../assets/img/Web_Select_Plan_Privacy.png"/> -->
      <div class="footer__legal">
        You agree to our
        <a
          class="footer__legal--link"
          href="https://studio.live/privacy/"
          target="_blank"
        >privacy policy</a>
        and
        <a
          class="footer__legal--link"
          href="https://studio.live/tos/"
          target="_blank"
        >terms of use</a>
        when&nbsp;subscribing
        <!-- <img class="footer__legal" src="../assets/img/simple/footer__legal.png" /> -->
        <!-- <span class="footer__legal--currency">
            Pricing shown is in USD. Customers in Australia will be billed 20.49 AUD a month or 139.99 AUD a year.
            Customers in Canada will be billed 18.99 CAD a month or 124.99 CAD a year.
        </span>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectPlan',
  props: ['member', 'stripe-plans'],
  data () {
    return {
      planType: false
    }
  },
  methods: {
    selectPlan (type) {
      console.log(type)

      this.planType = type
      this.next(type)
    },
    next (type) {
      this.$emit('next', type)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.screen {
  background: url("../assets/img/vignette.png"),
    url("../assets/img/Background_Pay.jpg");
  background-position: center center, 70% 0;
  background-size: cover, cover;
  background-repeat: repeat, no-repeat;
}

@media only screen and (min-width: 320px) and (max-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {
  .screen {
    background: url("../assets/img/vignette.png"),
      url("../assets/img/Background_Pay_s.jpg");
    background-position: center center, 70% 0;
    background-size: cover, cover;
    background-repeat: repeat, no-repeat;
  }
}

.container {
  height: 100vh;
  max-height: 450px;
  justify-content: space-between;
}

.header {
  color: #fff;
  text-transform: uppercase;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  align-items: center;
  /* border: solid 1px red; */
  margin-bottom: 20px;
}

.header__copy {
  text-align: left;
  line-height: 125%;
}

.header__avatar {
  border-radius: 100%;
  flex: 1;
  width: 100px;
  height: 100px;
  margin: 5px 15px 5px 0;
}

.plans-container img {
  margin: 10px 0;
}

.footer__legal {
  margin: 20px;
  display: block;
  color: #eee;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectPlan.vue